<template>
    <div
        id="dateSelector"
        class="dateSelector d-flex flex-row my-2 w-100 border-top border-bottom align-items-center overflow-scroll"
    >
        <div class="d-flex" v-for="(item, index) in dates" :key="index">
            <input
                @change="changeSelection"
                type="radio"
                :id="index.toString() + item.monthName"
                name="item-date"
                v-model="selection"
                :value="item.dateString"
                class="d-none"
            />
            <label
                :for="index.toString() + item.monthName"
                :id="item.day + '/' + item.month"
                class="item text-light d-flex flex-row align-items-center justify-content-center rounded-pill py-1 px-3 h-auto ms-1"
            >
                <strong>{{ item.day }}</strong>
                <p class="m-0 ms-1 h-auto">{{ item.monthName }}</p>
            </label>
        </div>
        <div class="space" id="space"></div>
    </div>
</template>
<script lang="ts">
import reportsModule from '@/store/modules/reports.module'
import dayjs from 'dayjs'
import 'dayjs/locale/es'
import { Vue, Component } from 'vue-property-decorator'

@Component({})
export default class DateSelector extends Vue {
    selection: string = dayjs().locale('es').format('DD/MM/YYYY')
    dates: any[] = []

    created() {
        dayjs.locale('es')
        this.formatDates()
    }

    mounted() {
        this.moveScroll()
    }

    changeSelection() {
        const value = this.selection
        console.log(value)
        reportsModule.picker.fromDate.setDate(dayjs(value, 'DD/MM/YYYY').toDate())
        reportsModule.picker.toDate.setDate(dayjs(value, 'DD/MM/YYYY').toDate())
    }

    formatDates() {
        let list = []
        let date = dayjs()
        for (let i = 0; i < 16; i++) {
            const aux = date.subtract(i == 0 ? 0 : 1, 'day')
            date = aux
            let monthName = aux.format('MMM')
            let month = aux.format('MM')
            const dateString = aux.format('DD/MM/YYYY')
            monthName = monthName.charAt(0).toUpperCase() + monthName.slice(1)
            list.unshift({
                day: date.format('DD'),
                monthName,
                dateString,
                month,
            })
        }
        this.dates = list
    }
    moveScroll() {
        const div = document.getElementById('dateSelector')!
        const space = document.getElementById('space')!
        space.style.marginLeft = (div.offsetWidth % (85 + 4)) + 'px'
        div.scrollLeft = div.scrollWidth
    }
}
</script>
<style lang="sass" scoped>
@import '@/assets/style/variables.sass'
.dateSelector
    height: 60px
    overflow-y: hidden !important
    .item
        border: 2px solid $primary
        color: $primary !important
        background-color: #fff
        height: fit-content !important
        transition: all 0.1s ease
        width: 85px
        &:active
            transform: scale(0.95)
    input
        &:checked + label
            background: $primary
            color: #fff !important
    .space
        margin-left: 20%
</style>
